import { FlaskConical } from 'lucide-react';

/**
 * Says whose view this is, on the one screen of the take flow that addresses the
 * client directly rather than asking about their household (Feature 118).
 *
 * The sharing step is kept in a test run rather than skipped — it is where an
 * advisor finds out whether they will see a client's results, which makes it the
 * screen most worth meeting before a client does. But kept as-is it asked the
 * advisor to share their results with themselves, by name. The copy below it
 * says "your advisor" instead, and this explains why.
 *
 * Shared by both completion screens so the two question sets cannot end up
 * explaining the same thing differently.
 */
export function SelfTestNotice() {
  return (
    <div className="mx-auto mb-5 flex max-w-md items-start gap-2 rounded-lg border border-dashed border-gray-300 bg-gray-50 px-3 py-2 text-left">
      <FlaskConical className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden />
      <p className="text-[13px] leading-snug text-gray-600">
        <span className="font-semibold text-gray-700">Test run.</span> This is the choice your
        client is given here. Pick either one — your own report stays open to you.
      </p>
    </div>
  );
}
